<template>
  <switcher-field v-if="bordered"
                  v-bind="$attrs" />
  <input-switcher v-else
                  v-bind="$attrs" />
</template>

<script>
  import InputSwitcher from './InputSwitcher.vue';
  import SwitcherField from './SwitcherField.vue';

  export default {
    components: {
      SwitcherField,
      InputSwitcher,
    },
    props: {
      bordered: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
